import ProjCardList from './proj-card-list';
export default ProjCardList;
